import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { ModalEl } from "common/components/modal";
import img from "./rebrand-image.jpg";
export function template() {
  return /* @__PURE__ */ jsx(ModalEl, {
    sel: ".rebrand-modal",
    attrs: { elref: `rebrand-modal`, open: this.state.open, closeable: true, "hide-close-button": true },
    on: { change: this.handleRebrandModalStateChanged }
  }, /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("img", {
    sel: ".rebrand-modal-img",
    attrs: { src: img }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".rebrand-modal-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".rebrand-modal-title"
  }, "A Brand New Mixpanel"), /* @__PURE__ */ jsx("div", {
    sel: ".rebrand-modal-body"
  }, /* @__PURE__ */ jsx("div", null, "It's time for us to imagine and pursue a more exciting future in analytics. We're evolving our brand to match."), /* @__PURE__ */ jsx("div", {
    sel: ".rebrand-modal-buttons"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    attrs: { theme: ButtonTheme.Tertiary },
    on: { click: () => this.update({ open: false }) }
  }, "Dismiss"), /* @__PURE__ */ jsx(ButtonEl, {
    attrs: { theme: ButtonTheme.Primary },
    on: { click: this.handleReadAboutItButtonClicked }
  }, "Read About It"))))));
}
